(function () {
  var TAG_PREFIX = 'casino wolinak |';
  var THRESHOLD = 4;

  function hasCompanyTag(tags) {
    return tags.some(function (t) {
      return typeof t === 'string' && t.trim().toLowerCase().indexOf(TAG_PREFIX) === 0;
    });
  }

  function init(employee) {
    var tags = (employee.tags || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    if (!hasCompanyTag(tags)) return;

    var inventoryMap = employee.variantInventory || {};
    var isFrench = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;

    var STATES = {
      in: {
        color: '#56ad6a',
        icon: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-in-stock" viewBox="0 0 22 22"><path d="m6 11.5 3 3 7-7"></path><path d="M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10Z"></path></svg>',
        text: function () { return isFrench ? "L'article est en stock" : 'Item is in stock'; }
      },
      low: {
        color: '#f79554',
        icon: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-low-inventory" viewBox="0 0 22 22"><path d="M11 6v6m0 4.01.01-.011M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10Z" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
        text: function (qty) {
          return isFrench
            ? "Dépêchez-vous, il n'en reste plus que <span data-remaining-count=\"\">" + qty + '</span>!'
            : 'Hurry, Only <span data-remaining-count="">' + qty + '</span> Left!';
        }
      },
      out: {
        color: '#721c24',
        icon: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-out-of-stock" viewBox="0 0 22 22"><path d="M8.172 13.828 11.001 11m0 0 2.828-2.828M11.001 11 8.172 8.172M11.001 11l2.828 2.828M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10Z" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
        text: function () {
          return isFrench
            ? "L'article est en rupture de stock, mais peut tout de même être commandé"
            : 'Item is out of stock, but you can still order it';
        }
      },
      unavailable: {
        color: '#721c24',
        icon: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-out-of-stock" viewBox="0 0 22 22"><path d="M8.172 13.828 11.001 11m0 0 2.828-2.828M11.001 11 8.172 8.172M11.001 11l2.828 2.828M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10Z" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
        text: function () { return isFrench ? "L'article n'est pas disponible" : 'Item is unavailable'; }
      }
    };

    function noticeHTML(state, qty) {
      var s = STATES[state];
      return (
        '<div class="product__block variant__countdown block-padding count-is-' + state + ' cw-low-stock-notice" ' +
        'data-remaining-max="' + THRESHOLD + '" data-remaining-show-notice="always" data-remaining-wrapper="" ' +
        'style="--block-padding-bottom: 16px;--icon-size:20px;">' +
        '<span class="variant__countdown--' + state + '" style="--icon-color: ' + s.color + '">' +
        s.icon +
        '<span class="variant__countdown-text">' + s.text(qty) + '</span>' +
        '</span></div>'
      );
    }

    function findHolder() {
      return document.querySelector('.product__block.product__form__holder');
    }

    function getSelectedVariantId() {
      var input = document.querySelector('input[type="hidden"][name="id"]');
      if (input && input.value) return Number(input.value);
      var v = new URLSearchParams(window.location.search).get('variant');
      return v ? Number(v) : null;
    }

    // Only ever fires for variants the native block can't handle (continue-selling ones),
    // so this and the native "Inventory countdown" block never both show at once.
    function getState(info) {
      if (!info) return null;
      if (info.available === false) return 'unavailable';
      if (info.policy !== 'continue') return null;
      if (typeof info.qty !== 'number') return null;
      if (info.qty <= 0) return 'out';
      if (info.qty <= THRESHOLD) return 'low';
      return 'in';
    }

    function findNativeCountdown() {
      return document.querySelector('.product__block.variant__countdown:not(.cw-low-stock-notice)');
    }

    function render() {
      var holder = findHolder();
      if (!holder) return;

      var existing = document.querySelector('.cw-low-stock-notice');
      if (existing) existing.remove();

      var native = findNativeCountdown();
      var variantId = getSelectedVariantId();
      var info = variantId ? inventoryMap[String(variantId)] : null;
      var state = getState(info);

      if (!state) {
        // Native block is relevant for this variant (or we have nothing to show) — make sure it's visible.
        if (native) native.style.removeProperty('display');
        return;
      }

      // We're covering this variant ourselves — hide the native block so it doesn't leave blank space.
      if (native) native.style.setProperty('display', 'none', 'important');
      holder.insertAdjacentHTML('beforebegin', noticeHTML(state, info.qty));
    }

    var lastVariantId = null;
    function tick() {
      var id = getSelectedVariantId();
      if (id !== lastVariantId) {
        lastVariantId = id;
        render();
      }
    }
    tick();
    setInterval(tick, 300);
  }

  var queue = window.CasinoWolinakLowStockQueue || [];
  queue.forEach(init);
  window.CasinoWolinakLowStockQueue = { push: init };
})();